
import { Component, Vue } from "vue-property-decorator";
import Axios from "axios";
import {
  isSubdomain,
  EventBus,
  getAPIAuthorizedHeader,
} from "@/services/common";
const Avatar = () => import("vue-avatar");
import $ from "jquery";
import { Socket } from "vue-socket.io-extended";
import { API_STORE } from "../../../../config";
 $(function () {
   $(document).on('click','#toggle-btn1',function(e) {  
        $('#toggle-btn1').toggleClass('active');
        $('.side-navbar').toggleClass('shrinked');
        $('.content-inner').toggleClass('active');
        $(document).trigger('sidebarChanged');
        if ($(window).outerWidth() > 1183) {
            if ($('#toggle-btn1').hasClass('active')) {
                $('.navbar-header .brand-small').hide();
                $('.navbar-header .brand-big').show();
            } else {
                $('.navbar-header .brand-small').show();
                $('.navbar-header .brand-big').hide();
            }
        }
        if ($(window).outerWidth() < 1183) {
            $('.navbar-header .brand-small').show();
        }
    });
    }); 
@Component({ components: { Avatar } })
export default class DashboardComponent extends Vue {
  public showUserIcons = false;
  public userName = null;
  public profileImageUrl = null;
  public clientLogo = null;
  public companyName = "Instant Payment";
  public walletAmount = 0.0;

  @Socket() // --> listens to the event by method name, e.g. `connect`
  connect() {
    console.log("connection established");
  }
  @Socket("onNotification")
  onNotification(value) {
    console.log(value);
    if (Array.isArray(value)) {
    } else {
    }
  }

  public routeFromLogo() {
    if (this.$client) this.$router.push("/portal");
    else this.$router.push("/superAdmin");
  }
  async logout(router) {
    if (window.location.href.includes(this.$DOMAIN_ADDRESS)) {
      await this.$store.dispatch("allClear");
      Vue.prototype.$client = null;
      Vue.prototype.$adminId = null;
      Vue.prototype.$companyName = null;
      Vue.prototype.$clientPermission = null;
      Vue.prototype.$clientLogo = null;
    } else await this.$store.dispatch("clearSession");
    // this.$socket.client.emit("userDisconnected", {
    //   keyName: "InstantPayment",
    //   userId: this.$userId,
    // });
    this.$router.push("/login");
  }

  async addUpiFund(){
    
  }

  public async getWalletAmount() {
      let response = await Axios.get(API_STORE.COMMON + "getWalletAmount", {
        params: {
          userId: this.$userId,
        },
        headers: getAPIAuthorizedHeader(),
      });
      if (response && response.data) {
        this.walletAmount = response.data.walletAmount;
      }
  }
  mounted() {
    this.clientLogo = this.$clientLogo;
    this.companyName = this.$companyName;
    this.userName = this.$userName;
    this.profileImageUrl = this.$profileImageUrl;

    /* Use emitter to emit data when user update profileimage and username */
    EventBus.$on("updateUserInfo", (data) => {
      this.profileImageUrl = this.$profileImageUrl;
      this.userName = this.$userName;
    });

    /* Use emitter to update client portal */
    EventBus.$on("updateClientInfo", (data) => {
      this.clientLogo = this.$clientLogo;
      this.companyName = this.$companyName;
    });

    /* Use emitter to update client portal */
    EventBus.$on("updateWalletAmount", (data) => {
      this.walletAmount = this.walletAmount + data.amount;
    });

    /* Use emitter to update client portal */
    EventBus.$on("refreshWalletAmount", (data) => {
      this.getWalletAmount();
    });

    this.showUserIcons = !this.$lodash.isEmpty(this.$store.state.sessionObject);
    this.getWalletAmount();

  }
}
